/**
 * Build a Google web search URL for a user question string.
 * @param {string} query
 */
export function buildGoogleSearchUrl(query) {
  const q = query != null ? String(query).trim() : "";
  if (!q) return "";
  return `https://www.google.com/search?q=${encodeURIComponent(q)}`;
}

/**
 * Open Google search in a new tab for the given question.
 * @param {string} query
 */
export function openGoogleSearch(query) {
  const url = buildGoogleSearchUrl(query);
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
}
